"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOnClick = getOnClick;
exports.default = ProfileInteractionActionsDropdown;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _Code = _interopRequireDefault(require("UIComponents/elements/Code"));

var _loggers = require("customer-data-tracking/loggers");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _userEnvHelpers = require("crm_ui/utils/userEnvHelpers");

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _CommunicatorActions = require("customer-data-communicator/data/communicator/actions/CommunicatorActions");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _UIMultiLevelDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIMultiLevelDropdown"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ShortcutBlock = (0, _styledComponents.default)(_Code.default).withConfig({
  displayName: "ProfileInteractionActionsDropdown__ShortcutBlock",
  componentId: "sc-1ywhngl-0"
})(_templateObject(), _colors.CALYPSO_MEDIUM);
var DROPDOWN_WIDTH = 228;
var communicatorInteractions = [_InteractionTypes.LOGGED_EMAIL, _InteractionTypes.LOGGED_CALL, _InteractionTypes.LOGGED_MEETING, _InteractionTypes.NOTE, _InteractionTypes.SCHEDULE, _InteractionTypes.TASK, _InteractionTypes.CALL, _InteractionTypes.EMAIL];

function getNonCommunicatorOnClick(_ref) {
  var interaction = _ref.interaction,
      handleOpenSequencesModal = _ref.handleOpenSequencesModal;

  switch (interaction) {
    case 'sequence':
    default:
      return function () {
        _loggers.CrmLogger.log('selectedActionsRedesignOption', {
          action: 'opened communicator from activity redesign',
          subAction: 'sequence',
          source: 'record actions dropdown'
        });

        handleOpenSequencesModal();
      };
  }
}

function getOnClick(_ref2) {
  var interaction = _ref2.interaction,
      handleOpenSequencesModal = _ref2.handleOpenSequencesModal,
      subjectId = _ref2.subjectId,
      objectType = _ref2.objectType;

  if (!communicatorInteractions.includes(interaction)) {
    return getNonCommunicatorOnClick({
      interaction: interaction,
      handleOpenSequencesModal: handleOpenSequencesModal
    });
  }

  return function () {
    _loggers.CrmLogger.log('selectedActionsRedesignOption', {
      action: 'opened communicator from activity redesign',
      subAction: interaction.split('-').join(' '),
      source: 'record actions dropdown'
    });

    (0, _CommunicatorActions.showCommunicator)(interaction);
    (0, _CommunicatorActions.setCommunicatorTriggerLocation)({
      triggerLocation: 'profile actions dropdown',
      subjectIdContext: subjectId,
      objectTypeContext: objectType
    });
  };
}

function ProfileInteractionActionsDropdown(_ref3) {
  var disabled = _ref3.disabled,
      handleOpenSequencesModal = _ref3.handleOpenSequencesModal,
      showSequences = _ref3.showSequences;

  var _useContext = (0, _react.useContext)(_SubjectContext.SubjectContext),
      objectType = _useContext.objectType,
      subjectId = _useContext.subjectId;

  function getButtonLabelKey(interaction) {
    switch (interaction) {
      case 'email':
        return 'profileTimeline.actionLabels.email';

      case 'logged-email':
        return 'profileTimeline.actionLabels.logged-email';

      case 'note':
        return 'profileTimeline.actionLabels.note';

      case 'activity':
        return 'profileTimeline.actionLabels.activity';

      case 'call':
        return 'profileTimeline.actionLabels.call';

      case 'logged-call':
        return 'profileTimeline.actionLabels.logged-call';

      case 'schedule':
        return 'profileTimeline.actionLabels.schedule';

      case 'logged-meeting':
        return 'profileTimeline.actionLabels.logged-meeting';

      case 'task':
        return 'profileTimeline.actionLabels.task';

      case 'sequence':
        return 'profileTimeline.actionLabels.sequence';

      default:
        return null;
    }
  }

  function renderShortcutBlock(contents) {
    return _react.default.createElement(ShortcutBlock, null, contents);
  }

  function getModifierKey() {
    if ((0, _userEnvHelpers.isMac)()) {
      return '⌘';
    }

    return _react.default.createElement(_FormattedMessage.default, {
      message: "profileTimeline.interactionActionsDropdown.shortcutReminder.ctrlKey"
    });
  }

  function getActionKey() {
    if ((0, _userEnvHelpers.isEdge)() || (0, _userEnvHelpers.isFirefox)()) {
      return '/';
    }

    return 'k';
  }

  function renderShortcutReminderSection() {
    var alertTitle = _react.default.createElement(_FormattedMessage.default, {
      message: "profileTimeline.interactionActionsDropdown.shortcutReminder.title"
    });

    var alertBody = _react.default.createElement(_FormattedReactMessage.default, {
      message: "profileTimeline.interactionActionsDropdown.shortcutReminder.body",
      options: {
        commandKey: renderShortcutBlock(getModifierKey()),
        shortcutKey: renderShortcutBlock(getActionKey())
      }
    });

    return _react.default.createElement("div", {
      className: "p-x-3"
    }, _react.default.createElement(_UIAlert.default, {
      use: "inline",
      titleText: alertTitle
    }, alertBody));
  }

  function getOption(interaction) {
    return {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: getButtonLabelKey(interaction)
      }),
      onClick: getOnClick({
        interaction: interaction,
        handleOpenSequencesModal: handleOpenSequencesModal,
        subjectId: subjectId,
        objectType: objectType
      })
    };
  }

  function getCallOption() {
    return getOption(_InteractionTypes.CALL);
  }

  function getLoggedActivityOption() {
    return {
      label: _react.default.createElement(_FormattedMessage.default, {
        message: getButtonLabelKey(_InteractionTypes.LEGACY_ACTIVITY)
      }),
      options: [getOption(_InteractionTypes.LOGGED_CALL), getOption(_InteractionTypes.LOGGED_EMAIL), getOption(_InteractionTypes.LOGGED_MEETING)]
    };
  }

  function getOptions() {
    return [[getOption(_InteractionTypes.NOTE), getOption(_InteractionTypes.TASK)], [getCallOption(), getOption(_InteractionTypes.EMAIL), getLoggedActivityOption(), getOption(_InteractionTypes.SCHEDULE)].concat(showSequences ? getOption('sequence') : []), [renderShortcutReminderSection()]];
  }

  var dropdownLabel = _react.default.createElement(_FormattedMessage.default, {
    message: "profileTimeline.interactionActionsDropdown.dropdownLabel"
  });

  return _react.default.createElement("div", {
    className: "p-top-5 p-right-4"
  }, _react.default.createElement(_UIMultiLevelDropdown.default, {
    buttonUse: "primary",
    buttonText: dropdownLabel,
    buttonSize: "small",
    disabled: disabled,
    menuWidth: DROPDOWN_WIDTH,
    placement: "bottom left",
    options: getOptions()
  }));
}

ProfileInteractionActionsDropdown.propTypes = {
  disabled: _propTypes.default.bool,
  handleOpenSequencesModal: _propTypes.default.func.isRequired,
  showSequences: _propTypes.default.bool
};